<div class="notice-modal">
  <div class="modal-header d-flex justify-content-between align-items-center">
    <div class="modal-title">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7H13V13H11V7ZM11 15H13V17H11V15Z" fill="#000000"/>
      </svg>
      <h4 class="notice-title">{{ title }}</h4>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <hr class="mt-2 mb-0 text-muted">
  <div class="modal-body">
    <p class="message-text">{{ messageText }}</p>
  </div>

  <div class="modal-footer d-flex justify-content-end align-items-center border-0 pt-0">
    <button *ngIf="isShowConnectAmazonAdsButton" class="company-setting__amazon-ads__connect" (click)="connectAmazonAds()">
      <img src="assets/images/svg/logo-asc.svg" alt="">
      <span>Login Amazon Advertising</span>
    </button>
    <button type="button" class="btn btn-confirm d-flex align-items-center" (click)="onConfirm()"
      *ngIf="confirmText!==null" [disabled]="isSyncInProcess"
    >
      {{ confirmText }}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-2">
        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div>
